<template>
  <x-dialog
    v-model="showValue"
    :mask-close="maskClose"
    :can-scroll="canScroll"
    @on-hide="$emit('on-hide')"
    @on-show="$emit('on-show')"
  >
    <div class="ssui-dialog" :class="{ 'ssui-dialog--no-title': !title }" ref="dialogContent">
      <div class="ssui-dialog__hd">
        <span v-if="title" class="ssui-dialog__title">{{title}}</span>
        <div v-if="hasClose" @click="showValue = false" class="ssui-dialog__close"><div></div></div>
      </div>
      <div class="ssui-dialog__bd">
        <div><slot></slot></div>
      </div>
      <div v-if="hasBtn" class="ssui-dialog__ft" :class="{ 'ssui-dialog__ft--double-btn': isDoubleBtn }">
        <x-button v-if="isDoubleBtn" type="small:secondary" @btn-click="$emit('on-cancel')">{{ cancelText }}</x-button>
        <x-button type="small:main" @btn-click="$emit('on-confirm')">{{ confirmText }}</x-button>
      </div>
    </div>
  </x-dialog>
</template>

<script>
import XDialog from '../x-dialog'
import XButton from '../x-button'

const DIALOG_CONTENT_LINE_HEIGHT = 19

export default {
  components: {
    XDialog,
    XButton,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    maskClose: {
      type: Boolean,
      default: false
    },
    hasClose: {
      type: Boolean,
      default: true
    },
    title: String,
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    isDoubleBtn: {
      type: Boolean,
      default: true
    },
    canScroll: {
      type: Boolean,
      default: true
    },
    // 考虑不要不要加
    hasBtn: {
      type: Boolean,
      default: true
    },
  },
  created () {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value
    }
  },
  // 提前获取内容的高度，以确定是否需要文字居中
  mounted () {
    let node = this.$refs.dialogContent.cloneNode(true)
    node.style.position = 'fixed'
    node.style.top = '-9999px'
    node.style.left = '-9999px'
    node.style.visibility = 'hidden'
    document.body.appendChild(node)
    const contentHeight = node.querySelector('.ssui-dialog__bd > div').offsetHeight
    if (contentHeight > DIALOG_CONTENT_LINE_HEIGHT * 2) {
      this.$refs.dialogContent.querySelector('.ssui-dialog__bd > div').style.textAlign = 'left'
    }
    document.body.removeChild(node)
    node = null
  },
  watch: {
    value (val) {
      this.showValue = val
    },
    showValue (val) {
      this.$emit('input', val)
    }
  },
  data () {
    return {
      showValue: false
    }
  },
}
</script>



// WEBPACK FOOTER //
// index.vue?a0349da2